import gql from "graphql-tag";

import { Fragment, QuestionOptionsConfiguration } from "../types";

export const QUESTION_OPTIONS_CONFIGURATION_FRAGMENT = gql`
  fragment QuestionOptionsConfigurationFragment on QuestionOptionsConfiguration {
    id
    locale
    skillQuestionOptionsConfiguration
    evaluationQuestionOptionsConfiguration
  }
`;

export type QuestionOptionsConfigurationFragment = Fragment<
QuestionOptionsConfiguration,
  Pick<
  QuestionOptionsConfiguration,
    | "id"
    | "locale"
    | "skillQuestionOptionsConfiguration"
    | "evaluationQuestionOptionsConfiguration"
  >
>;
